<template>
	<div class="justify-center w-full gap-6 ">
		<div class="w-full justify-center">
			<div class="w-full">
				<BaseButton
					@click="$router.push({ name: 'AppsEmployeeRepairPlanTasks' })"
					class="btn-default h-16 items-center flex justify-center my-4 w-full"
				>
					{{ $t('repair_schedule') }}
				</BaseButton>
			</div>
			<div>
				<BaseButton
					@click="$router.push({ name: 'AppsEmployeeWorkingimages' })"
					class="btn-default h-16 items-center flex justify-center my-4 w-full"
					v-if="!isRepairProofExists"
				>
					{{ $t('work_images') }}
				</BaseButton>
			</div>
			<div>
				<BaseButton @click="checkDamageAssessor" class="btn-default h-16 items-center flex justify-center my-4 w-full" v-if="!isRepairProofExists">
					{{ $t('repair_extension') }}
				</BaseButton>
			</div>
			<div>
				<BaseButton @click="openRepairProof" class="btn-default h-16 items-center flex justify-center my-4 w-full">
					<font-awesome-icon :icon="['fas', 'check']" class="mr-4 text-green-700" v-if="isRepairProofExists" />
					{{ $t('photos_after_repair_finished') }}
				</BaseButton>
			</div>
			<div>
				<button @click="logout" class="btn-default h-16 items-center flex justify-center my-4 w-full text-red-700">
					Logout
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import AppsEmployee from '@/mixins/AppsEmployee';
import BaseButton from '@/components/forms/buttons/BaseButton';
export default {
	name: 'AppsEmployeeMain',
	components: { BaseButton },
	mixins: [AppsEmployee],
	computed: {
		isDamageAssessor() {
			return this.getAppsEmployeeDamageCase?.damage_assessor?.id;
		},
	},
	methods: {
		checkDamageAssessor() {
			if (this.getAppsEmployeeDamageCase?.damage_assessor == null && this.getAppsEmployeeDamageCase?.process_type === 'liability') {
				this.$swal({
					title: this.$t('general.attention').toString(),
					text: this.$t('no_damage_assessor_in_case', { name: this.getAppsEmployeeDamageCase?.customerConsultant }).toString(),
					icon: 'warning',
				});
			} else {
				this.$router.push({ name: 'AppsEmployeeRepairExtension' });
			}
		},
		openRepairProof() {
			if (!this.isRepairProofExists) {
				this.$router.push({ name: 'AppsEmployeeRepairProof' });
			} else {
				this.$swal({
					title: this.$t('sure').toString(),
					text: this.$t('photos_repair_finished_overwrite').toString(),
					cancelButtonText: this.$t('general.no').toString(),
					showCancelButton: true,
					confirmButtonText: this.$t('general.yes').toString(),
				}).then(result => {
					if (result.value) {
						this.$router.push({ name: 'AppsEmployeeRepairProof' });
					}
				});
			}
		},
	},
};
</script>

<style scoped></style>
